import * as amplitude from "@amplitude/analytics-browser";
import { checkTeamForAICompliance } from "@redotech/redo-agents-common/util/compliance-util";
import { useAskRedoSlidePanel } from "@redotech/redo-merchant-app-common/ask-redo/ask-redo-slide-panel-context";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import { Flex } from "@redotech/redo-web/flex";
import { memo, useContext } from "react";
import { PlatformEvents } from "../../../platform-events";
import { SetupGuideNavButton } from "../../../setup-guide/setup-guide-nav-button";
import { AskRedoButton } from "./ask-redo-button";
import * as css from "./merchant-top-navigation.module.css";
import { NotificationsButton } from "./notifications-button";
import { SearchButton } from "./search-button";
import { TeamSwitcher } from "./team-switcher";

export const MerchantAppTopNav = memo(function MerchantAppTopNav() {
  const { toggle: toggleAskRedo } = useAskRedoSlidePanel();
  const team = useContext(TeamContext);

  const isAiBlacklisted =
    team && !checkTeamForAICompliance(team._id.toString());

  return (
    <Flex
      align="center"
      className={css.topNav}
      justify="space-between"
      w="full"
    >
      <Flex
        align="center"
        className={css.section}
        gap="lg"
        justify="flex-start"
      >
        <TeamSwitcher />
      </Flex>

      <Flex align="center" className={css.section} gap="lg" justify="center">
        <SearchButton />
      </Flex>

      <Flex align="center" className={css.section} gap="md" justify="flex-end">
        <SetupGuideNavButton />
        <NotificationsButton />
        {!isAiBlacklisted && (
          <AskRedoButton
            onClick={() => {
              amplitude.track(PlatformEvents.NAV_ASK_REDO_CLICKED);
              toggleAskRedo();
            }}
          />
        )}
      </Flex>
    </Flex>
  );
});
